module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAICAYAAAAftBSpAAAA30lEQVQoU2NkwAOuXr3KpqCosvT/v38zeHg49+JSyohL4v///yxfvv1axcjAEMjAwPCVmYnJk5OT9TA29VgNWfX/P7PX119LGBgZIhCaGD/9/fPHnZ+f6wS6QRiG/P//n/Hrt1/zGRgY4jFs/c/wgZGN0Zmbje0cshyGIV+//pr5n+F/Gp6gesvKwuDIzs5+GaYGxZDPX39MYmRgzMUX2GC5//9fsbIy2rOzs98AceGGfPnys4uBkaGUoAEIBc9YmP/bc3Bw3AEb8vnrzyZGBoZaEgwAK2VkZHj0i/GfPQB2vkQGox8zjgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dingdan/pop_icon_sign.png
// module id = DvV1
// module chunks = 1